export default {
  info: { method: 'get', url: '/game-api/super-consensus/info' },
  getOrder: { method: 'post', url: '/game-api/super-consensus/getOrder' },
  purchaseList: { method: 'get', url: '/game-api/super-consensus/purchaseList' },
  dividendList: { method: 'get', url: '/game-api/super-consensus/dividendList' }
}
